import React, { useEffect } from "react";
import { Outlet, useLocation, useSearchParams, Link } from "react-router-dom";
import Topbar from "./Topbar";
import Header from "./Header";
import Footer from "./Footer";
import FloatingActions from "./FloatingActions";
import CartDrawer from "./CartDrawer";
import SiteGate, { ShopStatusBanner } from "./SiteGate";
import RetentionPopup from "./RetentionPopup";
import { track } from "../../lib/api";
import { ArrowLeft, Sparkles } from "lucide-react";

export default function PublicLayout() {
  const loc = useLocation();
  const [sp] = useSearchParams();
  useEffect(() => {
    window.scrollTo(0, 0);
    track("pageview");
  }, [loc.pathname]);

  const isShop = loc.pathname.startsWith("/shop") || loc.pathname.startsWith("/account");
  const isDemoVitrine = sp.get("demo") === "vitrine" || sessionStorage.getItem("cockpit_demo_origin") === "vitrine";

  return (
    <SiteGate>
      <div className="min-h-screen flex flex-col bg-[hsl(var(--background))]">
        {isDemoVitrine && <DemoVitrineExitBar/>}
        <Topbar />
        <Header />
        {isShop && <ShopStatusBanner />}
        <main className="flex-1">
          <Outlet />
        </main>
        <Footer />
        <FloatingActions />
        <CartDrawer />
        <RetentionPopup />
      </div>
    </SiteGate>
  );
}

// =====================================================
// DemoVitrineExitBar — Phase 27
// Barre sticky en haut de la page démo public, avec
// bouton « Retour à l'accueil COCKPIT ».
// =====================================================
function DemoVitrineExitBar() {
  const exit = () => {
    sessionStorage.removeItem("cockpit_demo_origin");
  };
  return (
    <div
      className="sticky top-0 z-[60] bg-gradient-to-r from-violet-600 via-fuchsia-600 to-violet-600 text-white px-4 py-2.5 flex items-center justify-between gap-3 shadow-md"
      data-testid="demo-vitrine-exit-bar"
    >
      <div className="flex items-center gap-2 text-sm">
        <Sparkles className="w-4 h-4 text-amber-200"/>
        <span className="font-semibold">Mode démonstration</span>
        <span className="hidden sm:inline text-white/80 text-xs">— données fictives, contenu réinitialisé toutes les 24h</span>
      </div>
      <Link
        to="/"
        onClick={exit}
        className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg bg-white/20 hover:bg-white/30 backdrop-blur transition text-sm font-semibold"
        data-testid="demo-exit-button"
      >
        <ArrowLeft className="w-4 h-4"/>
        <span>Retour COCKPIT</span>
      </Link>
    </div>
  );
}
